const schedulingLinkMergeField = {
  key: 'scheduling_link',
  name: 'components.lexical.merge_fields.Scheduling Link',
  placeholder: 'components.lexical.merge_fields.#[Scheduling Link]'
};

export default schedulingLinkMergeField;
